module.exports = __webpack_public_path__ + "static/media/obi-wan-kenobi.2a7254c2.jpg";